import * as H from "history";
import { OtherSupportType } from "./acf";

export type WPImage = {
    url: string;
    sizes:
        | undefined
        | {
              thumbnail: string /** 150px */;
              medium: string /** 300px */;
              medium_large: string /** 768px */;
              large: string /** 1024px */;
          };
};

export type WPLink = {
    title: string;
    target: string;
    url: string;
};

export interface SiteData {
    siteURL: string;
    themeURL: string;
    ajaxURL: string;
    pageID: string;
    nonce: string;
    installPath: string;
    siteName: string;
    features: Features;
    isAdmin: boolean;
    acf: GlobalAcf;
    regions_mapping: GlobalRegionMapping;
}

export interface AcfPostObject {
    ID: number;
    link: string;
    post_title: string;
    post_name: string; // is actually the slug
}

export type Link = {
    title: string;
    url: string;
    target: string;
};

export type LinkRepeater = Array<{
    link: Link;
}>;

export type GlobalElement = {
    title: string;
    copy: string;
    button: WPLink;
    button_2?: WPLink;
    image: WPImage;
};

export type GlobalLinksKeys =
    | "saved_items_page"
    | "feedback_page"
    | "listing_feedback_page"
    | "local_services_page"
    | "not_sure_where_to_begin_page"
    | "i_need_help_now_page"
    | "languages_page"
    | "for_health_professionals";

export type GlobalLinks = Record<GlobalLinksKeys, AcfPostObject>;

export type Features = {
    local_information?: boolean;
    for_health_professionals?: boolean;
};

export type RegionRedirect = {
    name: string;
    redirect_url: string;
};

export type RegionMapping = {
    name: string;
    // url: string;
    postcodes: string;
};

export type GlobalAcf = {
    global_links: GlobalLinks;
    footer: {
        links: LinkRepeater;
        acknowledgements: string;
        additional_acknowledgements: string;
        region_blurb: string;
        region_logo: WPImage;
        copyright: string;
    };
    global_elements: {
        not_sure_where_to_begin: GlobalElement;
        other_support: OtherSupportType;
    };
    general: {
        google_analytics_id: string;
        is_ga_v4: null | boolean;
        meta_description: string;
        social_image: WPImage;
    };
    custom_page_titles: {
        populations: string;
        conditions: string;
        local_information: string;
        challenging_situations: string;
    };
    features: Features;
    mappings: {
        community_mappings: {
            lgbtq: number;
            atsi: number;
            faith_based_or_community_group: number;
            carer: number;
            military_personnel_and_veterans: number;
            new_and_expecting_parents: number;
            rural_and_remote_people: number;
        };
        gender_mappings: {
            male: number;
            female: number;
            non_binarygender_fluid: number;
            different_identity: number;
        };
    };
    form_mappings: {
        general_feedback: string;
        listing_feedback: string;
    };
    // regions_mapping: RegionMapping[];
    suburb_select_modal: {
        title: string;
        description: string;
        not_available_error: string;
    };
    suburb_select_carousel: {
        title: string;
        description: string;
        not_available_error: string;
        services_select_suburb_image: WPImage;
        services_select_suburb_mobile_image: WPImage;
    };
};

export type GlobalRegionMapping = {
    name: string;
    url: string;
    postcodes: string;
    region_blurb: string;
    region_logo: {
        url: string;
    };
    notification_bar: {
        enabled: boolean;
        content: string;
    };
};

export type GlobalData = {
    site: SiteData;
    acf: undefined | GlobalAcf;
    regions_mapping: any | GlobalRegionMapping;
};

export type BreadcrumbType = { title: string; link: string };

export type BreadcrumbsType = BreadcrumbType[];

export const KNOWN_WPPOST_FIELDS = [
    "id",
    "content",
    "title",
    "acf",
    "link",
    "date",
    "modified",
    "breadcrumbs",
    "type",
    "template",
    "slug",
];

export type WPPost<ACFType = unknown> = {
    id: number;
    content: { rendered: string };
    title: { rendered: string };
    acf: ACFType;
    link: string;
    date: string;
    modified: string;
    breadcrumbs: BreadcrumbsType;
    type: string;
    template: string;
    slug: string;
};

export const KNOWN_WPTAXTERM_FIELDS = ["id", "slug", "name", "taxonomy", "count", "acf"];
export interface WPTaxTerm {
    id: number;
    slug: string;
    name: string;
    taxonomy: string;
    count: number;
    acf: { nswtb_process_title: string };
}

export type RouteProps = {
    location: H.Location;
};

export type CoordType = {
    lat: number;
    lng: number;
};

export type Location = {
    name: string;
    state: string;
    postcode: number;
    lat: number;
    lng: number;
};

export type PersistedLocationInformation = Location & {
    regionUrl: string;
};

export enum SortModes {
    DistanceFromSuburb,
    DistanceFromUser,
}
